import React, { useState, useEffect } from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import { H3, H4 } from "components/Typography";
import { load, remove } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import DashboardNavbar from "components/DashboardNavbar";
import * as Models from "../../models";
import { toast } from "react-hot-toast";
import { cancelMFSIP, skipMFSIP } from "../../redux/actions/PortfolioAction";
import CircularProgress from "@mui/material/CircularProgress";
import aesEncrypt from "../../constants/aesEncrypt";
import SIPCard from "components/SIPCard";
import OTPModel from "components/OTPModel";
import { useNavigate, useLocation } from "react-router-dom";
import { getSIPList } from "../../redux/actions/PortfolioAction";
import moment from "moment";

export default function ActiveSIP() {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  let routeData = useLocation();

  const [loading, setLoading] = useState(false);
  const [onMoreSelect, setOnMoreSelect] = useState<number>(-1);
  const [onPauseSelect, setOnPauseSelect] = useState<number>(-1);
  const [onCancelSelect, setOnCancelSelect] = useState<number>(-1);
  const [onDefaultSelect, setOnDefaultSelect] = useState<any>(-1);
  const [selected, setSelected] = useState<number>(-1);
  const [data, setData] = React.useState([]);

  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getAllSIPList();
    }
  };

  const onMorePressHandle = (index: any) => {
    console.log("------Indexx", index);
    setSelected(index);
    setOnMoreSelect(index);
    setOnPauseSelect(-1);
    setOnDefaultSelect(true);
    setOnCancelSelect(-1);
  };
  const onPausePressHandle = (index: any) => {
    if (selected === index) {
      setOnPauseSelect(index);
      setOnDefaultSelect(false);
      setOnCancelSelect(-1);
    } else {
      setOnDefaultSelect(true);
      setOnMoreSelect(-1);
      setOnPauseSelect(-1);
      setOnCancelSelect(-1);
    }
  };
  const onCancelPressHandle = (index: any) => {
    if (selected === index) {
      setOnCancelSelect(index);
      setOnMoreSelect(-1);
      setOnDefaultSelect(false);
      setOnPauseSelect(-1);
    } else {
      setOnPauseSelect(-1);
      setOnCancelSelect(-1);
      setOnMoreSelect(-1);
      setOnPauseSelect(-1);
    }
  };
  const onCrossPressHandle = () => {
    setOnCancelSelect(-1);
    setOnMoreSelect(-1);
    setOnPauseSelect(-1);
    setOnDefaultSelect(-1);
  };
  const getAllSIPList = async () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    dispatch(getSIPList(userDetails?.mfia_id, `${token}`))
      .then(async (response: any) => {
        if (response.statusCode == 200) {
          setData(response.data);
        }
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const onpressYesPauseSIP = async (item: any) => {
    console.log("----------------------------------",item)
    onCrossPressHandle();
    await skipMFSIPAction(item);
  };
  const onpressYesCancelSIP = async (item: any) => {
    await cancelMFSIPAction(item);
  };
  const skipMFSIPAction = async (item: any) => {
    setLoading(true);
    const format = "YYYY-MM-DD";
    var d = new Date();
    var fromDate = moment(new Date()).format(format);
    var endDate = moment(new Date(d.setMonth(d.getMonth() + 3))).format(format);
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.SkipRequest = {
      userId: userDetails.id,
      sipId: item?.sipId,
      fromDate: fromDate,
      toDate: endDate,
    };

    dispatch(skipMFSIP(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 200) {
          toast.success(`Your sip is successfully paused.`);
          getAllSIPList();
          onCrossPressHandle();
          return;
        }
        toast.error(response?.message);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };

  const cancelMFSIPAction = async (item: any) => {
    if (item.state != "active") {
      toast.error(
        "You don't have units to process this request or try after 48hrs"
      );
      return;
    }
    setLoading(true);
    let token = await load("token");
    dispatch(cancelMFSIP(item?.sipId, `${token}`))
      .then(async (response: any) => {
        setLoading(false);

        if (response.statusCode === 200) {
          toast.success(`Your sip is successfully cancelled.`);
          getAllSIPList();
          onCrossPressHandle();
          return;
        }
        toast.error(response?.error?.message);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(
          "Unable to process your request. Please try again after sometime."
        );
      });
  };
  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <DashboardNavbar />
          <Grid
            sx={{
              p: {
                md: 4,
                xs: 0,
                sm: 2,
              },
              background: "#F6F6F6",
              height: "100vh",
              paddingBottom: 0,
            }}
          >
            {/* <OTPModel
              open={openModal}
              handleClose={handleCloseModal}
              handleSave={handleSave}
            /> */}
            <Grid
              sx={{
                //alignItems:'center',
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: {
                    xs: 2,
                  },
                  mb: {
                    xs: -2,
                  },
                }}
              >
                <H3
                  sx={{
                    ml: 2,
                  }}
                >
                  Active SIP ({data?.length ?? 0})
                </H3>
              </Grid>

              {data?.length === 0 ? (
                <Grid
                  container
                  columns={16}
                  spacing={5}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "50vh",
                  }}
                >
                  <H4>No Active SIP</H4>
                </Grid>
              ) : (
                <Grid container columns={16} spacing={5} sx={sxStyleCard}>
                  {Array.isArray(data) &&
                    data?.map((item: any, index: number) => (
                      <SIPCard
                        data={item}
                        onPressMore={() => onMorePressHandle(index)}
                        onPressPause={() => onPausePressHandle(index)}
                        onPressCancel={() => onCancelPressHandle(index)}
                        onpressYesPauseSIP={onpressYesPauseSIP}
                        onpressYesCancelSIP={onpressYesCancelSIP}
                        onPressCross={() => onCrossPressHandle()}
                        moreValue={onMoreSelect === index ? true : false}
                        pausesipvalue={onPauseSelect === index ? true : false}
                        cancelsipvalue={onCancelSelect === index ? true : false}
                        defaultValue={
                          selected === index ? onDefaultSelect : true
                        }
                        index={index}
                      />
                    ))}
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}

const sxStyleCard = {
  mt: {
    md: 2,
    xs: 1,
  },
  mb: {
    md: 2,
    xs: 0,
  },
  pb: 2,
  display: "flex",
  // justifyContent: "center",
  alignItems: "stretch",
  cursor: "pointer",
  p: {
    xs: 2,
  },
  pl: {
    xs: 4,
  },
  pr: {
    xs: 2,
  },
  pt: {
    xs: 0,
  },
};
